export default __webpack_public_path__ + "static/media/BlogTemplate.e4803c81.png";